import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { ProductCategoryDetailService } from '../detail';
import { ProductCategoryEditService } from './edit.service';
import { DialogHelper, ExceptionHelper } from './../../../../helper';
import { ProductCategory } from './../../../../model';

@Component({
  templateUrl: './edit.component.html'
})
export class ProductCategoryEditComponent implements OnInit {

  @ViewChild('dangerModal') dangerModal: any;

  id = ''; // product category id
  model = new ProductCategory('', '');
  public largeModal;
  redirect = true;

  constructor(
    // private alertService: AlertService,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private formBuilder: FormBuilder,
    private productCatDetailService: ProductCategoryDetailService,
    private productCatEditService: ProductCategoryEditService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  ngOnInit() {
    this.getDetail();
  }

  editProductCat() {
    this.productCatEditService
      .edit(this.id, this.model)
      .subscribe(
        data => {
          if (data) {
            this.model = data;
            this.dialog.showModal('showSucModalBtn');
          }
        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = false;
        }
      );
  }

  getDetail() {
    this.productCatDetailService
      .getDetail(this.id)
      .subscribe(
        data => {
          if (data) {
            this.model = data;
          }
        },
        err => {
          $('.card').hide();
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = true;
        }
      );
  }

  closeSuccessModel() {
    this.router.navigate(['/home/product-category/detail/' + this.id]);
  }

  errorClose() {
    if (this.redirect){
      this.router.navigate(['/home/product-category']);
    }
    else {
      this.dangerModal.hide();
    }
      
  }


}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/edit/edit.component.ts